import { FloatingNotification } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { StatusWarning as StatusWarningIcon } from '@wix/wix-ui-icons-common';
import { useRouter } from 'next/router';
import React, { FunctionComponent, useEffect, useState } from 'react';

import { DATA_HOOKS } from '../../dataHooks';
import { useStore } from '../../zustand/stores';

export const ArticlePreviewNotification: FunctionComponent = () => {
  const {
    query: { preview },
  } = useRouter();
  const { isWixEmployee } = useStore((state) => state.userSlice);
  const { t } = useTranslation();
  // Preview is Wix-employee-only: a non-employee opening a ?preview=true link
  // must never see the banner (and, once drafts are fetched, never the draft either).
  const isPreviewAuthorized = preview === 'true' && isWixEmployee;
  const [isDisplay, setIsDisplay] = useState(isPreviewAuthorized);

  useEffect(() => {
    setIsDisplay(isPreviewAuthorized);
  }, [isPreviewAuthorized]);

  useEffect(() => {
    const bodyElm = document.body;
    if (isDisplay) {
      bodyElm.classList.add('preview');
    } else {
      bodyElm.classList.remove('preview');
    }
  }, [isDisplay]);

  return isDisplay ? (
    <FloatingNotification
      prefixIcon={<StatusWarningIcon />}
      dataHook={DATA_HOOKS.ARTICLE_PREVIEW_NOTIFICATION}
      type="warning"
      fullWidth
      onClose={() => {
        setIsDisplay(false);
      }}
      text={t('article.preview-notification')}
    />
  ) : null;
};
